import React, { createContext, useContext, useEffect, ReactNode } from "react";
import { ThemeContextType } from "../types";

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  const noop = () => {};

  const value: ThemeContextType = {
    theme: "dark",
    isDarkMode: true,
    toggleTheme: noop,
    setTheme: noop,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};
